'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { OutcomePill, type OutcomePillProps } from '@/components/ui/outcome-pill';
import { useMarketOutcomeColor } from '@/hooks/chart/use-outcome-color';
export function MarketOutcomePill(t0) {
  const $ = _c(7);
  let index;
  let marketPubkey;
  let props;
  if ($[0] !== t0) {
    ({
      marketPubkey,
      index,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = index;
    $[2] = marketPubkey;
    $[3] = props;
  } else {
    index = $[1];
    marketPubkey = $[2];
    props = $[3];
  }
  const {
    hue
  } = useMarketOutcomeColor(marketPubkey, index);
  const t1 = hue ?? null;
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <OutcomePill {...props} hue={t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}